{
  "version": 1,
  "asset_id": "da7ae563-cbcc-44c5-84a6-dd496458b846",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/da7ae563-cbcc-44c5-84a6-dd496458b846/ind-ecommerce-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/da7ae563-cbcc-44c5-84a6-dd496458b846/ind-ecommerce-640.avif",
  "original_filename": "ind-ecommerce-640.avif",
  "size": 5705,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:01Z"
}
